// app/javascript/controllers/confirm_delete.js

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-delete-partner').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const message = form.dataset.confirm || "Are you sure?";
      if (!confirm(message)) {
        event.preventDefault();
      }
    });
  });
});
